export default function ApiAccessPage() {
  return (
    <div className="mx-auto mt-8 max-w-xl rounded-[28px] border border-slate-200 bg-white p-6 shadow-sm dark:border-gray-700 dark:bg-gray-800">
      <h2 className="text-2xl font-semibold text-slate-900 dark:text-white">API Access</h2>
      <p className="mt-3 text-sm leading-7 text-slate-600 dark:text-slate-300">
        Integrate your journal with external tools using authenticated API access.
      </p>
      <div className="mt-5 rounded-2xl bg-slate-50 p-4 dark:bg-gray-900">
        <p className="text-sm font-semibold text-slate-900 dark:text-white">Base path</p>
        <code className="mt-2 block break-all text-sm text-slate-600 dark:text-slate-300">/api</code>
        <p className="mt-3 text-xs leading-6 text-slate-500 dark:text-slate-400">
          Requests resolve against the active workspace backend, so use your deployed app domain with this path.
        </p>
        <p className="mt-4 text-sm font-semibold text-slate-900 dark:text-white">Endpoints</p>
        <ul className="mt-2 list-disc pl-5 text-sm text-slate-600 dark:text-slate-300">
          <li>/trades</li>
          <li>/analytics</li>
          <li>/export</li>
        </ul>
        <p className="mt-3 text-xs text-slate-500">Authentication required. Request an API token from support.</p>
      </div>
      <a
        href="mailto:support@mekedge.com?subject=API%20Access"
        className="mt-5 inline-flex rounded-full bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-slate-700 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-200"
      >
        Request API Token
      </a>
    </div>
  );
}
